export const PhoneOutlineSVG = (props) => (
  <svg
    height={22}
    viewBox="0 0 22 22"
    width={22}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.946 16c2.843 2.804 6.48 5.175 8.768 4.99 4.309-.35 5.756-5.647 5.756-5.647l-4.99-2.762-1.662 1.86s-1.006 1.16-2.062.265c-.367-.31-1.364-1.393-2.275-2.291-.91-.898-2.007-1.88-2.323-2.242-.91-1.044.237-2.066.237-2.066L9.23 6.42 5.923 1S.897 2 .833 7.304C.807 9.598 3.104 13.197 5.947 16z"
      fill="none"
      stroke="currentColor"
    />
  </svg>
);
